<template>
  <v-btn icon @click="chat">
    <v-icon color="#fff">chat</v-icon>
  </v-btn>
</template>

<script>
export default {
  methods: {
    chat(){
      this.$store.dispatch('Users/chat')
    }
  }
}
</script>
